__turbopack_context__.v({
  "team-label": "styles-module__hvFlPW__team-label",
  "team-logo-img": "styles-module__hvFlPW__team-logo-img",
  "totaliser-buttons-flex": "styles-module__hvFlPW__totaliser-buttons-flex",
});
